module.exports = __webpack_public_path__ + "img/auto-take-care.edc6ad22.png";